import { render } from "./RiInfo.vue?vue&type=template&id=450d68fb"
import script from "./RiInfo.vue?vue&type=script&lang=js"
export * from "./RiInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "450d68fb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('450d68fb', __exports__)) {
    api.reload('450d68fb', __exports__)
  }
  
  module.hot.accept("./RiInfo.vue?vue&type=template&id=450d68fb", () => {
    api.rerender('450d68fb', render)
  })

}


export default __exports__